import getCsrfToken from '../../lib/csrfToken';

async function changePassword(oldPassword: string, newPassword: string, newPasswordConfirm: string) {
  let json = { "succeeded": false, "message": "パスワード変更エラーです。" };

  const formData = new FormData();
  formData.append('old_pw', oldPassword);
  formData.append('new_pw', newPassword);
  formData.append('new_pw_confirm', newPasswordConfirm);

  const headers: HeadersInit = new Headers();
  const token = getCsrfToken();
  if (token !== undefined) {
    headers.set('X-CSRFToken', token);
  }

  const resp = await fetch('/api/users/change_pw', {
    method: 'POST',
    headers: headers,
    body: formData
  });

  json = await resp.json();

  // Validate
  if (json.message === 'Old password is invalid') {
    json.message = '現在のパスワードが間違っています。The current password is incorrect.';
    return json;
  } else if (json.message === 'Empty') {
    json.message = '全ての項目が入力必須です。All items must be filled in.'
    return json;
  } else if (json.message === 'Incorrect new_pw pair') {
    json.message = '新しいパスワードと新しいパスワード（確認）が一致していません。The new password and the new password (confirmation) do not correspond.';
    return json;
  }
  else if (json.message === 'Same password') {
    json.message = '現在のパスワードと新しいパスワードが同じです。Current password and new password are the same.';
    return json;
  }
  else if (json.message === 'does not match regex') {
    json.message = '新しいパスワードは半角英小文字、大文字、数字をそれぞれ1文字以上含む文字列を設定してください。The new password has to be at least 8 characters long and include at least one lowercase letter, one uppercase letter, and one number.';
    return json;
  }

  if (json.succeeded) {
    json.message = 'パスワードが変更されました。The password has been successfully changed.';
  }

  return json;
}

export default changePassword;
